import { Product } from "./product";

export class TimeoutData {
    private _paymentMethod: string;
    private _creditCardBrand: string;
    private _product: Product;
    private _discounts: any;

    constructor(
        paymentMethod: string,
        creditCardBrand: string,
        product: Product,
        discounts: any
    ) {
        this._paymentMethod = paymentMethod;
        this._creditCardBrand = creditCardBrand;
        this._product = product;
        this._discounts = discounts;
    }

    public get discounts() {
        return this._discounts;
    }

    public get product() {
        return this._product;
    }

    public get creditCardBrand() {
        return this._creditCardBrand;
    }

    public get paymentMethod() {
        return this._paymentMethod;
    }

}